import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import SvgIcon from '../svg-icon/svg-icon';
import css from './index.scss';
import Button from '../../components/button/index';
import { Cross, Tick } from '../../helpers/icon-dictionary';
import messages from './messages';
import TextInput from '../text-input/index';

class BulkPasswordChange extends Component {
    constructor(props) {
        super(props);
        this.state = { canSubmit: false };
        this.handleOnInputChange = this.handleOnInputChange.bind(this);
    }
    handleOnInputChange = (event) => {
        if (event.target.value.trim() !== '') {
            this.setState({ canSubmit: true });
        } else {
            this.setState({ canSubmit: false });
        }

        this.props.handleOnChange(event);
    }

    render() {
        return (
            <div className={css.bulkPasswordChangeContainer}>
                <div className={css.icon}>
                    <SvgIcon icon={this.props.icon} />
                </div>
                <div className={css.title}>{this.props.title}</div>
                <TextInput
                    handleOnChange={this.handleOnInputChange}
                    maxLength={50}
                    name="Password"
                    placeholder={this.props.intl.formatMessage(messages.newPassword)}
                    value={this.props.bulkPasswordValue}
                />
                <div className={css.container}>
                    <Button
                        buttonContainer={css.cancel}
                        buttonContainerDisabled={css.cancelButtonDisabled}
                        disabled={this.props.isLoading}
                        handleOnClick={this.props.handleOnCancel}
                        icon={Cross}
                        iconClassName={css.iconClassName}
                        loading={this.props.isLoading} />
                    <Button
                        buttonContainer={css.ok}
                        buttonContainerDisabled={css.okButtonDisabled}
                        disabled={this.props.isLoading || !this.state.canSubmit}
                        handleOnClick={this.props.handleOnOk}
                        icon={Tick}
                        iconClassName={css.iconClassName}
                        loading={this.props.isLoading || !this.state.canSubmit} />
                </div>
            </div>
        );
    }
}

BulkPasswordChange.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    handleOnOk: PropTypes.func,
    handleOnCancel: PropTypes.func,
    handleOnChange: PropTypes.func,
    isLoading: PropTypes.bool,
    intl: intlShape.isRequired,
    bulkPasswordValue: PropTypes.string
};

export default injectIntl(styleable(css)(BulkPasswordChange));



// WEBPACK FOOTER //
// ./app/components/bulk-password-change/index.js